import { Toast } from "antd-mobile";
import moment from "moment";
import React, { useCallback, useState } from "react";
import { useWindowSize } from "react-use";
import instance from "../../../util/axios";
import { formatDateString } from "../../../util/date";
import { getQueryString } from "../../../util/getQueryString";
import StepFive, { OrderCost } from "./component/StepFive";
import StepFour, { OrderService } from "./component/StepFour";
import StepOne, { OrderInfo } from "./component/StepOne";
import StepSeven, { OrderSplit } from "./component/StepSeven";
import StepSix, { OrderCollection } from "./component/StepSix";
import StepThree, { ProductCard } from "./component/StepThree";
import StepTwo, { ProductInfo } from "./component/StepTwo";
import TrainingStepFive, {
  TrainingOrderCost,
} from "./component/TrainingStepFive";
import TrainingStepThree, {
  TrainingBudgetWrapper,
} from "./component/TrainingStepThree";
import TrainingStepTwo, { TrainingProduct } from "./component/TrainingStepTwo";
import "./index.css";

const customerId: string = getQueryString("customerId");

export const bottomBtnStyle: React.CSSProperties = {
  padding: 30,
  position: "fixed",
  width: "100%",
  bottom: 0,
  boxSizing: "border-box",
  background: "#fff",
  zIndex: 99,
};

export default function ZhengBaoOrder() {
  const { height } = useWindowSize();
  const [userId, setUserId] = useState("");
  const [currentStep, setCurrentStep] = useState<string>("1");
  const [userName, setUserName] = useState("");
  //0: 产品订单 1: 内训订单
  const [orderType, setOrderType] = useState<number>(0);

  const [form1, setForm1] = useState<OrderInfo>();
  const [form2, setForm2] = useState<ProductInfo[]>([]);
  const [form3, setForm3] = useState<ProductCard[]>([]);
  const [form4, setForm4] = useState<OrderService[]>([]);
  const [form5, setForm5] = useState<OrderCost>();

  const [trainingForm2, setTrainingForm2] = useState<TrainingProduct>({});
  const [trainingForm3, setTrainingForm3] = useState<TrainingBudgetWrapper>();
  const [trainingForm5, setTrainingForm5] = useState<TrainingOrderCost>();
  const [area, setArea] = useState<{
    userArea: string;
    userAreaName: string;
  }>({
    userArea: "",
    userAreaName: "",
  });

  const onSave = useCallback(
    async (
      orderSplitType,
      orderSplitData: OrderSplit[],
      collectionType,
      form6: OrderCollection[]
    ) => {
      let jsondata: any = {
        fields: [],
        id: "0",
        tableName: "正保产品订单",
        form: "销售及内训订单",
        version: "默认",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        关联表: null,
        detailName: "业绩拆分明细",
      };

      let fields = [
        {
          fieldName: "订单类型",
          fieldType: "string",
          unSaved: "0",
          fieldText: form1?.orderTypeName,
          fieldValue: form1?.orderType[0],
        },
        {
          fieldName: "customerId",
          fieldType: "string",
          unSaved: "0",
          fieldText: form1?.customer,
          fieldValue: form1?.customerName[0],
        },
        {
          fieldName: "客户类型",
          fieldType: "string",
          unSaved: "0",
          fieldText: form1?.customerTypeName,
          fieldValue: form1?.customerType[0],
        },
        {
          fieldName: "联系人",
          fieldType: "string",
          unSaved: "0",
          fieldText: form1?.contactName,
          fieldValue: form1?.contacts,
        },
        {
          fieldName: "是否内训订单",
          fieldType: "string",
          unSaved: "0",
          fieldText: orderType === 0 ? "否" : "是",
          fieldValue:
            orderType === 0
              ? "fef2a687f35c2936843e5ed03dfbc584"
              : "fef2a687f35c2936843e4ed03dfbc583",
        },
        {
          fieldName: "签约单位",
          fieldType: "string",
          unSaved: "0",
          fieldText: trainingForm2.agency || "",
          fieldValue: trainingForm2.agency || "",
        },
        {
          fieldName: "订单总额",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.订单总额,
          fieldValue:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.订单总额,
        },
        {
          fieldName: "收入总额",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.实收总额,
          fieldValue:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.实收总额,
        },
        {
          fieldName: "正保币",
          fieldType: "int",
          unSaved: "0",
          fieldText: form5?.正保币,
          fieldValue: form5?.正保币,
        },
        {
          fieldName: "学习卡",
          fieldType: "int",
          unSaved: "0",
          fieldText: form5?.学习卡,
          fieldValue: form5?.学习卡,
        },
        {
          fieldName: "应收总额",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.实收总额,
          fieldValue:
            orderType === 1 ? trainingForm5?.订单总额 : form5?.实收总额,
        },
        {
          fieldName: "销售业绩总额",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.销售业绩总额 : form5?.销售业绩总额,
          fieldValue:
            orderType === 1 ? trainingForm5?.销售业绩总额 : form5?.销售业绩总额,
        },
        {
          fieldName: "支付方式",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.支付方式名称 : form5?.支付方式名称,
          fieldValue:
            orderType === 1 ? trainingForm5?.支付方式[0] : form5?.支付方式[0],
        },
        {
          fieldName: "预计到款日期",
          fieldType: "date",
          unSaved: "0",
          fieldText:
            trainingForm5?.预计到款日期 || form5?.预计到款日期
              ? formatDateString(
                  orderType === 1
                    ? trainingForm5?.预计到款日期
                    : form5?.预计到款日期
                )
              : "",
          fieldValue:
            trainingForm5?.预计到款日期 || form5?.预计到款日期
              ? formatDateString(
                  orderType === 1
                    ? trainingForm5?.预计到款日期
                    : form5?.预计到款日期
                )
              : "",
        },
        {
          fieldName: "到款单位",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.收款单位名称 : form5?.收款单位名称,
          fieldValue:
            orderType === 1 ? trainingForm5?.收款单位[0] : form5?.收款单位[0],
        },
        {
          fieldName: "汇款单位",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1 ? trainingForm5?.汇款单位 : form5?.汇款单位,
          fieldValue:
            orderType === 1 ? trainingForm5?.汇款单位 : form5?.汇款单位,
        },
        {
          fieldName: "到款方式",
          fieldType: "string",
          unSaved: "0",
          fieldText: collectionType === 1 ? "分批到款" : "全部到款",
          fieldValue:
            collectionType === 1
              ? "fef2a687f35c2936843e3ed03dfbc582"
              : "fef2a687f35c2936843e3ed03dfbc581",
        },
        {
          fieldName: "订单拆分",
          fieldType: "string",
          unSaved: "0",
          fieldText: orderSplitType === 1 ? "是" : "否",
          fieldValue:
            orderSplitType === 1
              ? "fef2a687f35c2936843e3ed03dfbc583"
              : "fef2a687f35c2936843e3ed03dfbc584",
        },
        {
          fieldName: "advisorId",
          fieldType: "string",
          unSaved: "0",
          fieldText: userName,
          fieldValue: userId,
        },
        {
          fieldName: "分公司",
          fieldType: "string",
          unSaved: "0",
          fieldText: area.userAreaName,
          fieldValue: area.userArea,
        },
        {
          fieldName: "备注",
          fieldType: "string",
          unSaved: "0",
          fieldText: orderType === 1 ? trainingForm5?.备注 : form5?.备注,
          fieldValue: orderType === 1 ? trainingForm5?.备注 : form5?.备注,
        },
        {
          fieldName: "skuNames",
          fieldType: "string",
          unSaved: "0",
          fieldText:
            orderType === 1
              ? trainingForm2.productName
              : form2.map((item) => item.productName).join(","),
          fieldValue:
            orderType === 1
              ? trainingForm2.productName
              : form2.map((item) => item.productName).join(","),
        },
        {
          fieldName: "是否总裁审批",
          fieldType: "int",
          unSaved: "0",
          fieldText: "否",
          fieldValue: "2",
        },
        {
          fieldName: "workflowTemplateId",
          fieldType: "string",
          fieldValue: "ec4f846a6db74ec98395554a4c726a0f",
        },
        {
          fieldName: "version",
          fieldType: "string",
          fieldValue: "默认",
        },
        {
          fieldName: "creatorId",
          fieldType: "String",
          fieldValue: userId,
        },
        {
          fieldName: "createTime",
          fieldType: "date",
          fieldValue: moment().format("YYYY-MM-DD"),
        },
      ];
      jsondata.fields = fields;
      let detailData = [];
      let detail1: any = [];
      let detail2: any = [];
      if (orderType === 0) {
        let detail4: any = [];
        form2.forEach((item, i) => {
          const itemObj = {
            id: "0",
            detailName: "正保产品订单_产品",
            fields: [
              {
                fieldName: "序号",
                fieldType: "int",
                fieldValue: i + 1 + "",
              },
              {
                fieldName: "产品归属",
                fieldType: "string",
                fieldValue: item.product[0],
              },
              {
                fieldName: "产品分类",
                fieldType: "string",
                fieldValue: item.product[1],
              },
              {
                fieldName: "产品名称",
                fieldType: "string",
                fieldValue: item.product[2],
              },
              {
                fieldName: "单价",
                fieldType: "string",
                fieldValue: item.originalPrice || "0",
              },
              {
                fieldName: "课程名称",
                fieldType: "string",
                fieldValue: item.name,
              },
              {
                fieldName: "销售指导价",
                fieldType: "string",
                fieldValue: item.guidePrice || "0",
              },
              {
                fieldName: "数量",
                fieldType: "string",
                fieldValue: item.count + "",
              },
              {
                fieldName: "赠品类型",
                fieldType: "string",
                fieldValue:
                  item.gift && item.gift.length > 0 ? item.gift[1] : "",
              },
              {
                fieldName: "赠品",
                fieldType: "string",
                fieldValue:
                  item.gift && item.gift.length > 0 ? item.gift[2] : "",
              },
              {
                fieldName: "赠品采购价",
                fieldType: "string",
                fieldValue: item.giftPurchasePrice + "" || "0",
              },
              {
                fieldName: "赠品含税成本价",
                fieldType: "string",
                fieldValue: item.giftCostPrice || "0",
              },
              {
                fieldName: "赠品内部核算价",
                fieldType: "string",
                fieldValue: item.giftAccountingPrice || "0",
              },
              {
                fieldName: "应收小计",
                fieldType: "string",
                fieldValue: item.subtotal || "0",
              },
              {
                fieldName: "销售折扣",
                fieldType: "string",
                fieldValue: item.discount || "0",
              },
              {
                fieldName: "实收款",
                fieldType: "string",
                fieldValue: item.receipts || "0",
              },
              {
                fieldName: "远见收入",
                fieldType: "string",
                fieldValue: item.earnings || "0",
              },
              {
                fieldName: "业绩系数",
                fieldType: "string",
                fieldValue: item.coefficient || "0",
              },
              {
                fieldName: "销售业绩额",
                fieldType: "string",
                fieldValue: item.sales || "0",
              },
            ],
          };
          detail1.push(itemObj);
        });
        form3.forEach((item, i) => {
          if (item.productId) {
            const cardObj = {
              id: "0",
              detailName: "会员卡明细",
              fields: [
                {
                  fieldName: "memberPosition",
                  fieldType: "string",
                  fieldValue: i + 1 + "",
                },
                {
                  fieldName: "会员卡明细_产品名称",
                  fieldType: "string",
                  fieldValue: item.productId || "0",
                },
                {
                  fieldName: "会员卡明细_会员卡号",
                  fieldType: "string",
                  fieldValue: item.card || "",
                },
              ],
            };
            detail2.push(cardObj);
          }
        });
        form4.forEach((item) => {
          if (item.serviceData.length > 0) {
            item.serviceData.forEach((child) => {
              detail4.push({
                id: "0",
                detailName: "产品服务明细",
                fields: [
                  {
                    fieldName: "productServicePosition",
                    fieldType: "string",
                    fieldValue: item.code,
                  },
                  {
                    fieldName: "产品服务明细_产品名称",
                    fieldType: "string",
                    fieldValue: item.productId,
                  },
                  {
                    fieldName: "产品服务明细_服务名称",
                    fieldType: "string",
                    fieldValue: child.id[0],
                  },
                  {
                    fieldName: "产品服务明细_规格",
                    fieldType: "string",
                    fieldValue: child.spec,
                  },
                  {
                    fieldName: "产品服务明细_数量",
                    fieldType: "string",
                    fieldValue: child.quantity || "0",
                  },
                ],
              });
            });
          }
        });
        detailData.push(detail4);
      } else {
        detail1.push({
          id: "0",
          detailName: "正保产品订单_内训",
          fields: [
            {
              fieldName: "内训_序号",
              fieldType: "int",
              fieldValue: "1",
            },
            {
              fieldName: "内训_产品名称",
              fieldType: "string",
              fieldValue:
                trainingForm2.product && trainingForm2.product.length > 0
                  ? trainingForm2.product[0]
                  : "",
            },
            {
              fieldName: "内训_单价",
              fieldType: "string",
              fieldValue: trainingForm2.amount || "0",
            },
            {
              fieldName: "内训_预计毛利",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.预计毛利 || "0",
            },
            {
              fieldName: "内训_预计毛利率",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.预计毛利率 || "0",
            },
            {
              fieldName: "内训_收入额",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.收入额 || "0",
            },
            {
              fieldName: "内训_业绩系数",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.业绩系数 || "0",
            },
            {
              fieldName: "内训_销售业绩额",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.销售业绩额 || "0",
            },
            {
              fieldName: "内训_应付小计",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.应付小计 || "0",
            },
            {
              fieldName: "内训_应收小计",
              fieldType: "string",
              fieldValue: trainingForm3?.disabledForm.应收小计 || "0",
            },
          ],
        });
        trainingForm3?.descriptions.forEach((item) => {
          detail2.push({
            id: "0",
            detailName: "成本预算明细",
            fields: [
              {
                fieldName: "预算类别",
                fieldType: "string",
                fieldValue: item.uuid,
              },
              {
                fieldName: "预算金额",
                fieldType: "double",
                fieldValue: item.amount || "",
              },
            ],
          });
        });
      }
      detailData.push(detail1);
      detailData.push(detail2);

      if (collectionType === 1) {
        let detail6: any = [];
        form6.forEach((item, i) => {
          detail6.push({
            id: "0",
            detailName: "到款方式明细",
            fields: [
              {
                fieldName: "到款方式明细_批次",
                fieldType: "string",
                fieldValue: i + 1 + "",
              },
              {
                fieldName: "到款方式明细_预计到款时间",
                fieldType: "string",
                fieldValue: item.collectionDate
                  ? formatDateString(item.collectionDate)
                  : "",
              },
              {
                fieldName: "到款方式明细_汇款单位",
                fieldType: "string",
                fieldValue: item.remitCompany || "",
              },
              {
                fieldName: "到款方式明细_还款金额",
                fieldType: "double",
                fieldValue: item.amount || "0",
              },
            ],
          });
        });
        detailData.push(detail6);
      }
      if (orderSplitType === 1) {
        let saleArr: any = [];
        let serviceArr: any = [];
        let detail7: any = [];

        orderSplitData.forEach((item, i) => {
          if (i === 0) {
            saleArr = item.splitData.map((data) => ({
              ...data,
              advisorType: item.advisorType,
            }));
          } else if (i === 1) {
            serviceArr = item.splitData.map((data) => ({
              ...data,
              advisorType: item.advisorType,
            }));
          }
        });
        const len =
          saleArr.length >= serviceArr.length
            ? saleArr.length
            : serviceArr.length;
        if (saleArr.length !== serviceArr.length) {
          if (saleArr.length > serviceArr.length) {
            for (let a = 0; a < saleArr.length - serviceArr.length; a++) {
              serviceArr.push({
                advisorId: "0",
                scale: "",
                advisorType: "服务地业务员",
              });
            }
          } else {
            for (let a = 0; a < serviceArr.length - saleArr.length; a++) {
              saleArr.push({
                advisorId: "0",
                scale: "",
                advisorType: "销售地业务员",
              });
            }
          }
        }
        for (let x = 0; x < len; x++) {
          let itemObj = {
            id: "0",
            detailName: "业绩拆分明细",
            fields: [
              {
                fieldName: saleArr[x].advisorType,
                fieldType: "string",
                fieldValue: saleArr[x].advisorId[0],
              },
              {
                fieldName: `${saleArr[x].advisorType}_比例`,
                fieldType: "int",
                fieldValue: saleArr[x].scale,
              },
              {
                fieldName: serviceArr[x].advisorType,
                fieldType: "string",
                fieldValue: serviceArr[x].advisorId[0],
              },
              {
                fieldName: `${serviceArr[x].advisorType}_比例`,
                fieldType: "int",
                fieldValue: serviceArr[x].scale,
              },
            ],
          };
          detail7.push(itemObj);
        }
        detailData.push(detail7);
      }
      const resp = await instance.post(`/wf/form/vsheet/saveData`, {
        jsonData: JSON.stringify(jsondata),
        detailData: JSON.stringify(detailData),
      });
      if (resp.data.Status === "1") {
        const submitResp = await instance.post(`/wf/form/vsheet/submit`, {
          id: resp.data.Data,
          name: "销售及内训订单",
          version: "默认",
        });
        if (submitResp.data.Status === "1") {
          Toast.success("提交成功", 1);
          setTimeout(function () {
            window.location.href = "/colseWebView";
          }, 2000);
        }
      } else {
        Toast.fail("提交失败", 1);
      }
    },
    [
      form1,
      form2,
      form3,
      form4,
      form5,
      trainingForm2,
      trainingForm3,
      trainingForm5,
      orderType,
      userName,
      userId,
      area,
    ]
  );
  return (
    <div
      className="orderWrapper"
      style={{ backgroundColor: "white", minHeight: height }}>
      {currentStep === "1" ? (
        <StepOne
          defaultValues={form1}
          defaultType={orderType}
          customerId={customerId}
          onOk={(type, data, userId, name) => {
            setCurrentStep("2");
            setOrderType(type);
            setForm1(data);
            setUserId(userId);
            setUserName(name);
          }}
          onCancel={() => {
            window.location.href = "/colseWebView";
          }}
        />
      ) : currentStep === "2" ? (
        orderType === 0 ? (
          <StepTwo
            defaultValues={form2}
            userId={userId}
            onCancel={() => setCurrentStep("1")}
            onOk={(data, userArea, userAreaName) => {
              if (
                data.some(
                  (item) =>
                    item.product[1] === "6c2f89b5410640eaa394f8d3288709f7"
                )
              ) {
                setCurrentStep("3");
              } else {
                setCurrentStep("5");
              }

              setForm2(data);
              setArea({
                ...area,
                userArea: userArea,
                userAreaName: userAreaName,
              });
            }}
          />
        ) : (
          <TrainingStepTwo
            defaultValues={trainingForm2}
            onCancel={() => setCurrentStep("1")}
            onOk={(data) => {
              setCurrentStep("3");
              setTrainingForm2(data);
            }}
          />
        )
      ) : currentStep === "3" ? (
        orderType === 0 ? (
          <>
            {form2.length > 0 && (
              <StepThree
                defaultValues={form3}
                onCancel={() => setCurrentStep("2")}
                onOk={(data) => {
                  setCurrentStep("4");
                  setForm3(data);
                }}
                productData={form2}
              />
            )}
          </>
        ) : (
          <TrainingStepThree
            onCancel={() => setCurrentStep("2")}
            onOk={(data) => {
              setCurrentStep("5");
              setTrainingForm3(data);
            }}
            productData={trainingForm2}
          />
        )
      ) : currentStep === "4" ? (
        orderType === 0 ? (
          <StepFour
            defaultValues={form4}
            onCancel={() => setCurrentStep("3")}
            onOk={(data) => {
              setCurrentStep("5");
              setForm4(data);
            }}
            productData={form2}
          />
        ) : (
          <></>
        )
      ) : currentStep === "5" ? (
        orderType === 0 ? (
          <StepFive
            defaultValues={form5}
            defaultCompany={form1?.contactName}
            onCancel={() => {
              if (
                form2.some(
                  (item) =>
                    item.product[1] === "6c2f89b5410640eaa394f8d3288709f7"
                )
              ) {
                setCurrentStep("4");
              } else {
                setCurrentStep("2");
              }
            }}
            onOk={(data) => {
              setCurrentStep("7");
              setForm5(data);
            }}
            productData={form2}
          />
        ) : (
          <TrainingStepFive
            defaultValues={trainingForm5}
            defaultCompany={form1?.contactName}
            onCancel={() => setCurrentStep("3")}
            onOk={(data) => {
              setCurrentStep("7");
              setTrainingForm5(data);
            }}
            productData={trainingForm3}
          />
        )
      ) : currentStep === "7" ? (
        <StepSeven
          total={orderType === 0 ? form5!.实收总额 : trainingForm5!.实收总额}
          onCancel={() => setCurrentStep("5")}
          onOk={(type, data, collectionType, form6) => {
            onSave(type, data, collectionType, form6);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
